module.exports = __webpack_public_path__ + "img/options.9da1057d.svg";